function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled, { css } from 'styled-components';
import { addColors } from "../../helpers/helpers";
import { getButtonSize } from "./themeStyles";
import { addStyleByPredicateWithProps, addHoverStyle, addLoadingStyle, addDisabledStyle } from "./helpers";
import colors from "../../colors/index";
import { defaultTheme } from "../../theme/index";
import { addStyleIfPropTruly } from "../../utils/styledComponents";
var ButtonDefaultProps = {
  theme: _objectSpread({}, defaultTheme, {
    button: {
      borderRadius: {
        small: '3px',
        normal: '4px',
        large: '4px'
      },
      height: {
        small: 30,
        normal: 40,
        large: 50
      },
      padding: {
        small: '0 12px',
        normal: '0 16px',
        large: '0 24px'
      },
      bgColor: 'red',
      color: 'white',
      disabled: {
        bgColor: colors.paleGreyThree,
        color: colors.pinkishGrey
      },
      hover: {
        bgColor: colors.sageLight,
        borderColor: 'green'
      },
      active: {
        bgColor: colors.lightGreyGreenFour
      },
      focus: {
        bgColor: colors.lightGreyGreenThree
      },
      loading: {
        bgColor: colors.lightGreyGreenFour,
        color: 'green'
      },
      borderColor: 'red'
    }
  })
};
export var ButtonStyled = styled.button.withConfig({
  displayName: "ButtonStyled",
  componentId: "sc-1w8q6ko-0"
})(["display:flex;position:relative;align-items:center;justify-content:center;font:inherit;border:none;", " outline:none;cursor:pointer;transition:0.3s ease-in-out;max-width:100%;margin:0;", " ", " ", " ", " ", " ", ""], function (_ref) {
  var button = _ref.theme.button;
  return addColors({
    bgColor: button.bgColor,
    color: button.color || 'inherit',
    borderColor: button === null || button === void 0 ? void 0 : button.borderColor
  });
}, function (_ref2) {
  var button = _ref2.theme.button;
  return "font-family: ".concat((button === null || button === void 0 ? void 0 : button.fontFamily) || 'inherit', ";");
}, addDisabledStyle(css(["", ""], function (_ref3) {
  var theme = _ref3.theme;
  return addColors(theme.button.disabled);
})), addHoverStyle(css(["&:hover{", "}&:active{", "}&:focus{", "}"], function (_ref4) {
  var hover = _ref4.theme.button.hover;
  return addColors(hover);
}, function (_ref5) {
  var active = _ref5.theme.button.active;
  return addColors(active);
}, function (_ref6) {
  var focus = _ref6.theme.button.focus;
  return addColors(focus);
})), addLoadingStyle(css(["", ""], function (_ref7) {
  var theme = _ref7.theme;
  return "background-color: ".concat(theme.button.loading.bgColor, ";");
})), getButtonSize, addStyleByPredicateWithProps(function (_ref8) {
  var fluid = _ref8.fluid;
  return fluid;
}, 'width: 100%'));
ButtonStyled.defaultProps = ButtonDefaultProps;
export var ButtonChildrenWrapper = styled.div.withConfig({
  displayName: "ButtonStyled__ButtonChildrenWrapper",
  componentId: "sc-1w8q6ko-1"
})(["display:flex;align-items:center;justify-content:center;max-width:100%;width:100%;", ""], addStyleIfPropTruly('hide', 'visibility: hidden;'));
export var ButtonText = styled.span.withConfig({
  displayName: "ButtonStyled__ButtonText",
  componentId: "sc-1w8q6ko-2"
})(["text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%;display:inline-block;", ""], function (_ref9) {
  var _theme$button;

  var theme = _ref9.theme;
  return css(["font-weight:", ";"], theme === null || theme === void 0 ? void 0 : (_theme$button = theme.button) === null || _theme$button === void 0 ? void 0 : _theme$button.fontWeight);
});